<template>
  <b-modal
    :id="id"
    :centered="true"
    :hide-header="true"
    :hide-footer="false"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <slot></slot>
    <template #modal-footer>
      <b-button variant="secondary" @click="handleClickCancel">{{ cancelButtonText }}</b-button>
      <b-button variant="default" @click="handleClickConfirm">{{ confirmButtonText }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    id: {
      default() {
        return ''
      }
    },
    message: {
      default() {
        return ''
      }
    },
    cancelButtonText: {
      default() {
        return 'キャンセル'
      }
    },
    confirmButtonText: {
      default() {
        return 'OK'
      }
    }
  },
  methods: {
    handleClickConfirm() {
      this.$emit('on-click-confirm')
    },
    handleClickCancel() {
      this.$emit('on-click-cancel')
    }
  }
}
</script>
